import { EnvelopesMutationTypes } from "./mutation_types";
import { EnvelopesState } from './state'

export const mutations: StoreMutations<EnvelopesMutationTypes, EnvelopesState> = {
  [EnvelopesMutationTypes.SET_MY_ENVELOPES] (state, value) {
    state.myEnvelopes = value
  },
  [EnvelopesMutationTypes.SET_MY_ENVELOPES_ERROR] (state, value) {
    state.myEnvelopesError = value
  },
  [EnvelopesMutationTypes.SET_MY_ENVELOPES_PENDING] (state, value) {
    state.myEnvelopesPending = value
  },
}